import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchDashboardStats = createAsyncThunk(
  'dashboard/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=dashboard-stats');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const fetchRecentApplications = createAsyncThunk(
  'dashboard/fetchRecentApplications',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=dashboard-recent-apps');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const fetchRecentJobs = createAsyncThunk(
  'dashboard/fetchRecentJobs',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=dashboard-recent-jobs');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    stats: null,
    recentApplications: [],
    recentJobs: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchRecentApplications.fulfilled, (state, action) => {
        state.recentApplications = action.payload;
      })
      .addCase(fetchRecentJobs.fulfilled, (state, action) => {
        state.recentJobs = action.payload;
      });
  },
});

export const { clearError } = dashboardSlice.actions;
export default dashboardSlice.reducer;
